import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDeliveryDetail extends BaseModelAPI {
	static entity = 'suratjalandeliverydetail';
	static entityName = 'suratjalandeliverydetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.suratJalanDeliveryId = '';
			this.suratJalanDelivery = {};
			this.deliveryCardId = '';
			this.deliveryCard = {};
			this.partId = '';
			this.part = {};
			this.orderQty = 0;
			this.deliveryQty = 0;
			this.isLoading = false;
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}